import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=4f8eeab8&scoped=true&"
import script from "./RoleList.vue?vue&type=script&lang=js&"
export * from "./RoleList.vue?vue&type=script&lang=js&"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=4f8eeab8&prod&lang=scss&scoped=true&"
import style1 from "./RoleList.vue?vue&type=style&index=1&id=4f8eeab8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8eeab8",
  null
  
)

export default component.exports